const convertPathParams = string => {
  const pathArr = string.split('&');
  const result = {};
  pathArr.forEach(item => {
    const itemArr = item.split('=');
    // eslint-disable-next-line prefer-destructuring
    result[itemArr[0]] = itemArr[1];
  });

  return result;
};

export const getPathParams = (name = 'wemediaId') => {
  const search = window.location.href.split('?')[1];
  const params = new URLSearchParams(search);
  return params.get(name);
};

export const windowOpen = (host, path) => {
  const params = getPathParams();
  let uri = path;
  const [pathname, pathParams] = path.split('?');
  if (pathParams) {
    const obj = convertPathParams(pathParams);
    if (params) {
      obj.wemediaId = params;
      const str = new URLSearchParams(obj).toString();
      uri = `${pathname}?${str}`;
    }
  }
  if (!pathParams && params) {
    uri = `${pathname}?wemediaId=${params}`;
  }
  window.open(host ? host + uri : uri);
};

export const historyPush = (history, path, type = 'push') => {
  const params = getPathParams();
  let uri = path;
  const [pathname, pathParams] = path.split('?');
  if (pathParams) {
    const obj = convertPathParams(pathParams);
    if (params) {
      obj.wemediaId = params;
      const str = new URLSearchParams(obj).toString();
      uri = `${pathname}?${str}`;
    }
  }
  if (!pathParams && params) {
    uri = `${pathname}?wemediaId=${params}`;
  }
  if (type === 'push') {
    history.push(uri);
  } else {
    history.replace(uri);
  }
};
